/* Bluora — scripts propios. Todo vanilla, sin librerías. */
(function () {
  'use strict';

  var sinMovimiento =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada al hacer scroll ---------------------------- */
  function initReveals() {
    var elementos = document.querySelectorAll('.bl-reveal:not(.bl-visible)');
    if (!elementos.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) {
        el.classList.add('bl-visible');
      });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('bl-visible');
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    elementos.forEach(function (el) {
      observador.observe(el);
    });
  }

  /* --- Preguntas frecuentes (acordeón) ----------------------------------- */
  function initFaq() {
    var botones = document.querySelectorAll('.bl-faq__pregunta');
    if (!botones.length) return;

    botones.forEach(function (boton) {
      if (boton.dataset.blListo === '1') return;
      boton.dataset.blListo = '1';

      boton.addEventListener('click', function () {
        var item = boton.closest('.bl-faq__item');
        if (!item) return;

        var abierto = item.classList.contains('is-open');
        var lista = item.closest('.bl-faq__lista');

        if (lista) {
          lista.querySelectorAll('.bl-faq__item.is-open').forEach(function (otro) {
            if (otro === item) return;
            otro.classList.remove('is-open');
            var b = otro.querySelector('.bl-faq__pregunta');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }

        item.classList.toggle('is-open', !abierto);
        boton.setAttribute('aria-expanded', String(!abierto));
      });
    });
  }

  /* --- Cifras animadas ---------------------------------------------------- */
  function initCifras() {
    var cifras = document.querySelectorAll('[data-bl-contador]');
    if (!cifras.length) return;

    if (sinMovimiento || !('IntersectionObserver' in window)) return;

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          animaCifra(entrada.target);
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.5 }
    );

    cifras.forEach(function (el) {
      observador.observe(el);
    });
  }

  function animaCifra(el) {
    var destino = parseFloat(el.dataset.blContador);
    if (isNaN(destino)) return;

    var prefijo = el.dataset.blPrefijo || '';
    var sufijo = el.dataset.blSufijo || '';
    var decimales = (el.dataset.blContador.split('.')[1] || '').length;
    var inicio = null;
    var duracion = 1400;

    function paso(ahora) {
      if (inicio === null) inicio = ahora;
      var avance = Math.min((ahora - inicio) / duracion, 1);
      var suave = 1 - Math.pow(1 - avance, 3);
      el.textContent = prefijo + (destino * suave).toFixed(decimales) + sufijo;
      if (avance < 1) requestAnimationFrame(paso);
    }

    requestAnimationFrame(paso);
  }

  /* --- Galería de producto ------------------------------------------------ */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-bl-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-bl-galeria-principal]');
      var minis = galeria.querySelectorAll('[data-bl-galeria-mini]');
      if (!principal || !minis.length) return;

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          cambiaFoto(galeria, mini.dataset.blSrc, mini.dataset.blAlt || '');
          marcaMiniActiva(galeria, mini);
        });
      });
    });
  }

  function cambiaFoto(galeria, src, alt) {
    var principal = galeria.querySelector('[data-bl-galeria-principal]');
    if (!principal || !src || principal.getAttribute('src') === src) return;

    principal.style.opacity = '0';
    window.setTimeout(function () {
      principal.setAttribute('src', src);
      principal.setAttribute('alt', alt);
      principal.style.opacity = '1';
    }, 180);
  }

  function marcaMiniActiva(galeria, mini) {
    galeria.querySelectorAll('[data-bl-galeria-mini]').forEach(function (m) {
      m.classList.toggle('is-active', m === mini);
    });
  }

  /* --- Selector de variantes ---------------------------------------------- */
  function initVariantes() {
    var bloques = document.querySelectorAll('[data-bl-compra]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      var datos = bloque.querySelector('[data-bl-variantes]');
      if (!datos) return;

      var variantes;
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!variantes || !variantes.length) return;

      var botones = bloque.querySelectorAll('[data-bl-opcion]');
      if (!botones.length) return;

      botones.forEach(function (boton) {
        boton.addEventListener('click', function () {
          var indice = boton.dataset.blOpcion;
          bloque
            .querySelectorAll('[data-bl-opcion="' + indice + '"]')
            .forEach(function (b) {
              b.classList.toggle('is-active', b === boton);
            });

          var etiqueta = bloque.querySelector('[data-bl-elegido="' + indice + '"]');
          if (etiqueta) etiqueta.textContent = boton.dataset.blValor;

          aplicaVariante(bloque, variantes);
        });
      });

      aplicaVariante(bloque, variantes, true);
    });
  }

  function aplicaVariante(bloque, variantes, inicial) {
    var seleccion = [];
    bloque.querySelectorAll('[data-bl-opcion].is-active').forEach(function (b) {
      seleccion[parseInt(b.dataset.blOpcion, 10)] = b.dataset.blValor;
    });

    var variante = variantes.find(function (v) {
      return v.opciones.every(function (valor, i) {
        return seleccion[i] === undefined || seleccion[i] === valor;
      });
    });

    if (!variante) variante = variantes[0];

    var input = bloque.querySelector('[data-bl-variante-id]');
    if (input) input.value = variante.id;

    var precio = bloque.querySelector('[data-bl-precio]');
    if (precio) precio.innerHTML = variante.precio;

    var antes = bloque.querySelector('[data-bl-precio-antes]');
    if (antes) {
      if (variante.precio_antes) {
        antes.innerHTML = variante.precio_antes;
        antes.hidden = false;
      } else {
        antes.hidden = true;
      }
    }

    var boton = bloque.querySelector('[data-bl-anadir]');
    if (boton) {
      boton.disabled = !variante.disponible;
      if (variante.disponible) {
        boton.removeAttribute('aria-disabled');
      } else {
        boton.setAttribute('aria-disabled', 'true');
      }
      /* Solo el primer <span>: el segundo es el indicador de carga del tema. */
      var etiqueta = boton.querySelector('span');
      if (etiqueta) {
        etiqueta.textContent = variante.disponible
          ? boton.dataset.blTextoDisponible
          : boton.dataset.blTextoAgotado;
      }
    }

    var ya = bloque.querySelector('[data-bl-comprar-ya]');
    if (ya) ya.disabled = !variante.disponible;

    /* Al cambiar de acabado, muestra su foto en la galería */
    if (!inicial && variante.foto) {
      var galeria = document.querySelector('[data-bl-galeria]');
      if (galeria) {
        var mini = galeria.querySelector('[data-bl-src="' + variante.foto + '"]');
        cambiaFoto(galeria, variante.foto, variante.titulo);
        if (mini) marcaMiniActiva(galeria, mini);
      }
    }
  }

  /* --- Texto que entra palabra a palabra ---------------------------------- */
  function initTextoPartido() {
    var titulares = document.querySelectorAll('[data-bl-partir]:not(.bl-partido)');
    if (!titulares.length) return;

    titulares.forEach(function (titular) {
      partirNodo(titular);
      titular.classList.add('bl-partido');

      var palabras = titular.querySelectorAll('.bl-palabra > span');
      palabras.forEach(function (p, i) {
        p.style.transitionDelay = Math.min(i * 0.055, 0.9) + 's';
      });

      if (sinMovimiento || !('IntersectionObserver' in window)) {
        titular.classList.add('bl-visible');
        return;
      }

      var obs = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add('bl-visible');
            obs.unobserve(e.target);
          });
        },
        { threshold: 0.15 }
      );
      obs.observe(titular);
    });
  }

  /* Envuelve cada palabra sin romper <br> ni los <span> que ya hubiera. */
  function partirNodo(nodo) {
    var hijos = Array.prototype.slice.call(nodo.childNodes);

    hijos.forEach(function (hijo) {
      if (hijo.nodeType === 3) {
        var texto = hijo.textContent;
        if (!texto.trim()) return;

        var fragmento = document.createDocumentFragment();
        texto.split(/(\s+)/).forEach(function (trozo) {
          if (!trozo) return;
          if (!trozo.trim()) {
            fragmento.appendChild(document.createTextNode(' '));
            return;
          }
          var fuera = document.createElement('span');
          fuera.className = 'bl-palabra';
          var dentro = document.createElement('span');
          dentro.textContent = trozo;
          fuera.appendChild(dentro);
          fragmento.appendChild(fuera);
        });
        nodo.replaceChild(fragmento, hijo);
      } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR') {
        partirNodo(hijo);
      }
    });
  }

  /* --- Botones magnéticos -------------------------------------------------- */
  function initImanes() {
    if (sinMovimiento) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

    document.querySelectorAll('.bl-iman').forEach(function (el) {
      if (el.dataset.blListo === '1') return;
      el.dataset.blListo = '1';

      el.addEventListener('mousemove', function (ev) {
        var caja = el.getBoundingClientRect();
        var x = ev.clientX - caja.left - caja.width / 2;
        var y = ev.clientY - caja.top - caja.height / 2;
        el.style.transform = 'translate(' + x * 0.18 + 'px,' + y * 0.26 + 'px)';
      });

      el.addEventListener('mouseleave', function () {
        el.style.transform = '';
      });
    });
  }

  /* --- Escena con scroll (secuencia de fotogramas) ------------------------- */
  function initEscena() {
    document.querySelectorAll('[data-bl-escena]').forEach(function (escena) {
      if (escena.dataset.blListo === '1') return;
      escena.dataset.blListo = '1';

      var lienzo = escena.querySelector('[data-bl-escena-lienzo]');
      var datos = escena.querySelector('[data-bl-escena-fotogramas]');
      if (!lienzo || !datos) return;

      var urls;
      try {
        urls = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      if (!urls || !urls.length) return;

      var total = parseInt(escena.dataset.blTotal, 10) || urls.length;
      total = Math.min(total, urls.length);
      urls = urls.slice(0, total);

      /* En móvil usamos la mitad de fotogramas: se ve igual y pesa la mitad. */
      if (window.innerWidth < 750 && urls.length > 40) {
        urls = urls.filter(function (u, i) {
          return i % 2 === 0 || i === total - 1;
        });
        total = urls.length;
      }

      var ctx = lienzo.getContext('2d', { alpha: false });
      var imagenes = new Array(total);
      var listas = new Array(total);
      var pintado = -1;

      var capas = escena.querySelectorAll('[data-bl-capa]');
      var indicador = escena.querySelector('[data-bl-indicador]');
      var barra = escena.querySelector('[data-bl-escena-barra]');

      /* Los fotogramas miden 1400px de ancho: pasar de ahí solo emborrona. */
      var ANCHO_FUENTE = 1400;

      function dimensionar() {
        var caja = lienzo.getBoundingClientRect();
        if (!caja.width || !caja.height) return;

        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var ancho = caja.width * dpr;
        if (ancho > ANCHO_FUENTE) dpr = ANCHO_FUENTE / caja.width;
        dpr = Math.max(dpr, 1);

        var nuevoAncho = Math.round(caja.width * dpr);
        var nuevoAlto = Math.round(caja.height * dpr);
        if (nuevoAncho === lienzo.width && nuevoAlto === lienzo.height) return;

        lienzo.width = nuevoAncho;
        lienzo.height = nuevoAlto;
        pintado = -1;
        pinta(indiceActual());
      }

      function masCercano(i) {
        if (listas[i]) return i;
        for (var d = 1; d < total; d++) {
          if (i - d >= 0 && listas[i - d]) return i - d;
          if (i + d < total && listas[i + d]) return i + d;
        }
        return -1;
      }

      function pinta(i) {
        var real = masCercano(i);
        if (real < 0 || real === pintado) return;
        var img = imagenes[real];
        if (!img || !img.naturalWidth) return;

        var cw = lienzo.width;
        var ch = lienzo.height;
        var escala = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
        var w = img.naturalWidth * escala;
        var h = img.naturalHeight * escala;
        ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
        pintado = real;
      }

      function progreso() {
        var caja = escena.getBoundingClientRect();
        var recorrido = escena.offsetHeight - window.innerHeight;
        if (recorrido <= 0) return 0;
        var p = -caja.top / recorrido;
        return Math.max(0, Math.min(1, p));
      }

      function indiceActual() {
        return Math.round(progreso() * (total - 1));
      }

      function actualizaCapas(p) {
        capas.forEach(function (capa) {
          var desde = parseFloat(capa.dataset.blDesde);
          var hasta = parseFloat(capa.dataset.blHasta);
          if (isNaN(desde) || isNaN(hasta)) return;
          capa.classList.toggle('is-visible', p >= desde && p <= hasta);
        });

        if (indicador) indicador.classList.toggle('is-oculto', p > 0.06);
        if (barra) barra.style.width = p * 100 + '%';
      }

      /* Carga: primero el fotograma inicial, luego el resto por tandas. */
      function carga(i, alTerminar) {
        var img = new Image();
        img.decoding = 'async';
        img.onload = function () {
          listas[i] = true;
          if (alTerminar) alTerminar();
        };
        img.onerror = function () {
          if (alTerminar) alTerminar();
        };
        img.src = urls[i];
        imagenes[i] = img;
      }

      var siguiente = 1;
      function siguienteTanda() {
        if (siguiente >= total) return;
        var i = siguiente++;
        carga(i, function () {
          pinta(indiceActual());
          siguienteTanda();
        });
      }

      carga(0, function () {
        dimensionar();
        pinta(indiceActual());
        for (var k = 0; k < 6; k++) siguienteTanda();
      });

      /* ResizeObserver: el `resize` de la ventana no cubre todos los casos
         (paneles que cambian de ancho, barras del navegador en móvil...). */
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          dimensionar();
        }).observe(lienzo);
      }

      if (sinMovimiento) {
        actualizaCapas(0);
        window.addEventListener('resize', dimensionar);
        return;
      }

      var enCola = false;
      function alHacerScroll() {
        if (enCola) return;
        enCola = true;
        requestAnimationFrame(function () {
          enCola = false;
          var p = progreso();
          pinta(Math.round(p * (total - 1)));
          actualizaCapas(p);
        });
      }

      window.addEventListener('scroll', alHacerScroll, { passive: true });
      window.addEventListener('resize', dimensionar);
      actualizaCapas(progreso());
    });
  }

  /* --- Vídeo con botón de play (v2) ------------------------------------- */
  function initVideo() {
    document.querySelectorAll('[data-bl-video]').forEach(function (marco) {
      if (marco.dataset.blListo) return;
      marco.dataset.blListo = '1';

      var video = marco.querySelector('video');
      if (!video) return;

      // Modo fondo (solo, sin sonido, en bucle): si el visitante pide menos
      // movimiento, no arranca solo y se le dan los controles.
      if (marco.hasAttribute('data-bl-video-fondo')) {
        if (sinMovimiento) {
          video.removeAttribute('autoplay');
          video.pause();
          video.controls = true;
        }
        return;
      }

      var boton = marco.querySelector('[data-bl-video-play]');
      if (!boton) return;

      boton.addEventListener('click', function () {
        marco.classList.add('is-reproduciendo');
        video.controls = true;
        var promesa = video.play();
        if (promesa && promesa.catch) {
          promesa.catch(function () {
            marco.classList.remove('is-reproduciendo');
          });
        }
      });

      video.addEventListener('ended', function () {
        marco.classList.remove('is-reproduciendo');
        video.controls = false;
        boton.focus({ preventScroll: true });
      });
    });
  }

  /* --- Cantidad (− 1 +) y "Comprar ahora" (v2) ---------------------------- */
  function initCantidad() {
    document.querySelectorAll('[data-bl-cantidad]').forEach(function (caja) {
      if (caja.dataset.blListo) return;
      caja.dataset.blListo = '1';

      var campo = caja.querySelector('[data-bl-cantidad-valor]');
      if (!campo) return;

      function fija(valor) {
        var min = parseInt(campo.min, 10) || 1;
        var max = parseInt(campo.max, 10) || 99;
        campo.value = Math.min(max, Math.max(min, valor || min));
      }

      caja.querySelector('[data-bl-cantidad-menos]').addEventListener('click', function () {
        fija(parseInt(campo.value, 10) - 1);
      });
      caja.querySelector('[data-bl-cantidad-mas]').addEventListener('click', function () {
        fija(parseInt(campo.value, 10) + 1);
      });
      campo.addEventListener('change', function () {
        fija(parseInt(campo.value, 10));
      });
    });
  }

  function initComprarYa() {
    document.querySelectorAll('[data-bl-comprar-ya]').forEach(function (boton) {
      if (boton.dataset.blListo) return;
      boton.dataset.blListo = '1';

      boton.addEventListener('click', function () {
        var bloque = boton.closest('[data-bl-compra]');
        if (!bloque) return;
        var variante = bloque.querySelector('[data-bl-variante-id]');
        var cantidad = bloque.querySelector('[data-bl-cantidad-valor]');
        var anadir = bloque.querySelector('[data-bl-anadir]');
        if (!variante || (anadir && anadir.disabled)) return;

        var unidades = cantidad ? parseInt(cantidad.value, 10) || 1 : 1;
        boton.setAttribute('aria-busy', 'true');
        // Enlace de carrito de Shopify: crea el pedido con esa variante y va directo a pagar
        window.location.href = '/cart/' + variante.value + ':' + unidades;
      });
    });
  }

  /* --- Arranque ----------------------------------------------------------- */
  function initTodo() {
    initReveals();
    initFaq();
    initCifras();
    initGaleria();
    initVariantes();
    initEscena();
    initTextoPartido();
    initImanes();
    initVideo();
    initCantidad();
    initComprarYa();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }

  /* El editor de Shopify recarga secciones sueltas: reengancha lo necesario */
  document.addEventListener('shopify:section:load', initTodo);
})();
